import React from 'react';
import { Box, Rating, Typography } from "@mui/material";
import { TOrderFeedback } from '../types';
import StyledPaper from './StyledPaper';
import dayjs from "dayjs";
import * as relativeTime from 'dayjs/plugin/relativeTime' // import plugin

type MenuItemProps = {
    item: TOrderFeedback
}

const RestaurantReviewItem: React.FC<MenuItemProps> = (props) => {
    const {
        item
    } = props;

    dayjs.extend(relativeTime.default);
    return <StyledPaper
        onClick={() => { }}
        elevation={1}
        sx={{ display: 'flex', flexDirection: "column", borderRadius: '16px' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', flexDirection: "row", alignItems: 'center', borderRadius: '16px', height: 'unset', width: "100%" }}>
        <Box>
            <Typography variant='body1'>{item.customerName}</Typography>
            <Box pb='8px' />
            <Typography
                fontSize={'12px'}
                fontWeight={500}
                color={'#C0C0CF'}
            >
                {dayjs(item.createdAt).fromNow()}
            </Typography>
        </Box>
        <Rating
            readOnly
            size="large"
            name="simple-controlled"
            value={item.rating}
            onChange={(event, newValue) => {}}
        />
        </Box>
        {item.customerFeedback && <>
        <Box pb='20px' />
        <Typography variant='body1'>{item.customerFeedback}</Typography>
        </>
        }
        
    </StyledPaper>
}

export default RestaurantReviewItem;